var map = {
	"./IMG_2075.PNG": 789,
	"./IMG_2076.PNG": 62,
	"./IMG_2077.PNG": 95,
	"./IMG_2078.PNG": 872,
	"./IMG_2079.PNG": 377,
	"./IMG_2080.PNG": 865,
	"./IMG_2081.PNG": 944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 251;